"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sum = void 0;
var sum = function (arr) { return arr.reduce(function (acc, n) { return acc + n; }, 0); };
exports.sum = sum;
